module.exports = __webpack_public_path__ + "static/media/Guitar-5.61ab9e98.jpg";